module.exports = __webpack_public_path__ + "img/zy.d509e318.png";